module.exports = __webpack_public_path__ + "static/img/n3.7e725381.jpg";